import DOMPurify from 'dompurify';

// Matches what the admin RichTextEditor can actually produce (bold/italic/underline,
// lists, alignment/font-size via inline styles) - nothing else is allowed through.
const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'p', 'br', 'div', 'span', 'ul', 'ol', 'li', 'a'];
const ALLOWED_ATTR = ['style', 'href', 'target', 'rel'];

// DOMPurify keeps whatever value a `style` attribute has as long as `style` itself is
// allowed - it does not sanitize CSS content by default. Without this, something like
// style="background:url(javascript:alert(1))" would pass straight through. Only the
// specific declarations the editor actually generates are allowed; everything else in
// a style attribute is dropped.
const SAFE_STYLE_DECLARATION = /^(font-size:\s*\d+(\.\d+)?px|text-align:\s*(left|right|center|justify))$/i;

DOMPurify.addHook('uponSanitizeAttribute', (_node, data) => {
  if (data.attrName === 'style') {
    const safeDeclarations = data.attrValue
      .split(';')
      .map((d) => d.trim())
      .filter((d) => d && SAFE_STYLE_DECLARATION.test(d));
    data.attrValue = safeDeclarations.join('; ');
  }
});

/** Sanitize admin-authored rich text before rendering with dangerouslySetInnerHTML. */
export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), { ALLOWED_TAGS, ALLOWED_ATTR });
};
